//////////////////
// IMPORTS
//////////////////
import * as React from "react";
import { Link as RouterLink } from "found";
import { baseStyles, hoverStyles } from "./a.component";

//////////////////
// TYPES
//////////////////
interface IProps {
  to: string;
  toggleable?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  hoverStyle?: React.CSSProperties;
}

interface IState {
  hovered: boolean;
}

//////////////////
// COMPONENT
//////////////////
export class Link extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { hovered: false };
  }

  private onHover = (hovered: boolean) => {
    this.setState({ hovered });
  };

  public render() {
    const hoverStateStyle = this.state.hovered ? { ...hoverStyles, ...this.props.hoverStyle } : {};

    const styles = {
      ...baseStyles,
      ...this.props.style,
      ...hoverStateStyle,
    };
    return (
      <RouterLink
        style={styles}
        to={this.props.to}
        onMouseEnter={() => this.onHover(true)}
        onMouseLeave={() => this.onHover(false)}
      >
        {this.props.children}
      </RouterLink>
    );
  }
}
